var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendarChevronLeft = function SvgCalendarChevronLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "calendarChevronLeft_svg__a",
    width: 48,
    height: 48,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h48v48H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#calendarChevronLeft_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1C1B1F",
    d: "m20.907 24 8.146 8.146q.416.416.425 1.044.01.63-.425 1.064T28 34.688q-.618 0-1.054-.434l-8.988-8.988a1.7 1.7 0 0 1-.396-.593 1.9 1.9 0 0 1-.116-.673q0-.361.116-.673.116-.311.396-.593l8.988-8.988a1.45 1.45 0 0 1 1.045-.425q.628-.01 1.063.425t.435 1.054q0 .62-.435 1.054z"
  }))));
};
export default SvgCalendarChevronLeft;